import React from "react";

// assets importing
import LogoBusiness from "../../assets/LogoBusiness.jpg";
import LogoInstitute from "../../assets/LogoInstitute.jpg";
import LogoProduct from "../../assets/LogoProduct.png";

const FormLogo = () => {

  return (
    <div className="flex justify-between w-full md:h-[4rem] h-[2rem]">
      <img
        className="h-full pointer-events-none"
        src={LogoBusiness}
        alt=""
      />

      <img
        className="h-full pointer-events-none"
        src={LogoProduct}
        alt=""
      />

      <img
        className="h-full pointer-events-none"
        src={LogoInstitute}
        alt=""
      />
    </div>
  )
}

export default FormLogo
